module.exports = __webpack_public_path__ + "static/img/view5-3.a334bca.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/lobby/components1030/img/1030/view5-3.png
// module id = A0Im
// module chunks = 1